var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGraph(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.75 12.5V11",
    stroke: "black",
    strokeWidth: 1.125,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 12.5V10.25",
    stroke: "black",
    strokeWidth: 1.125,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.25 12.5V8.75",
    stroke: "black",
    strokeWidth: 1.125,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 4.25C5.8978 6.70123 8.92535 7.31097 11.856 6.49389M10.7661 5.3535L12.3213 6.11629C12.5057 6.20676 12.5555 6.41622 12.4325 6.58415L11.3952 8",
    stroke: "black",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0.875 8C0.875 4.64124 0.875 2.96187 1.91843 1.91843C2.96187 0.875 4.64124 0.875 8 0.875C11.3587 0.875 13.0381 0.875 14.0816 1.91843C15.125 2.96187 15.125 4.64124 15.125 8C15.125 11.3587 15.125 13.0381 14.0816 14.0816C13.0381 15.125 11.3587 15.125 8 15.125C4.64124 15.125 2.96187 15.125 1.91843 14.0816C0.875 13.0381 0.875 11.3587 0.875 8Z",
    stroke: "black",
    strokeWidth: 1.125,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraph);
export default __webpack_public_path__ + "static/media/Graph.56d8752e72e36120ae55e2422847ab3b.svg";
export { ForwardRef as ReactComponent };